/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import { CommentsIco } from '@shared/Icon/EtcIcon'
import AdvImg from '@components/AdvImg'

interface IMatchInfo {
  commentCount: number
}

interface CompanyPickCommentProps {
  matchInfo: IMatchInfo
  avatar: string
}

export const CompanyPickComment: React.FC<CompanyPickCommentProps> = observer((props): React.ReactElement => {
  const { matchInfo, avatar } = props
  const { commentCount } = matchInfo

  return (
    <div className="writer">
      <div className="user-profile">
        <div className="profile">
          <div className="profile-img-wrap lhn26">
            <AdvImg src={avatar} srcMode={'small'} alt="프로필 이미지" className="profile-img custom-img" loading="lazy"/>
          </div>
        </div>
      </div>
      <span className="num comment-num">
        <CommentsIco/>{commentCount}
      </span>
    </div>
  )
})
